import { render, staticRenderFns } from "./ModalFormularioCategoriaUniversidad.vue?vue&type=template&id=19483d32"
import script from "./ModalFormularioCategoriaUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalFormularioCategoriaUniversidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports